var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donut-overview"},[(_vm.calculatorDataSource.length)?_c('chart-donut-quiz',{attrs:{"dataSource":_vm.calculatorDataSource,"patternsCustom":_vm.customPattern,"colorBoder":_vm.colorBoder}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }